import {
  defaultAvatarHairColor,
  defaultAvatarShirtColor,
  defaultAvatarSkinTone,
} from 'enrollment/app/constants';

interface ChooseAvatarReducerType {
  payload: {
    id: string;
    code: string;
    name: string;
    redirectLink: string;
    objectURL: string;
    fileName: string;
    croppedImage: string;
    isCropped: boolean;
    chosenFamilyDisplay: string;
    isFamilyCropped: boolean;
    familyPictureObjectURL: string;
    familyPictureName: string;
  };
  type: string;
}

export const chooseAvatarReducer = (
  state = {
    avatar: null,
    avatarColorPalatteDisabled: false,
    chosenDisplay: null,
  },
  action: ChooseAvatarReducerType
) => {
  switch (action.type) {
    case 'CHOOSE_AVATAR':
      return {
        ...state,
        avatar: {
          id: action.payload.id,
          code: action.payload.code,
          name: action.payload.name,
          redirectLink: action?.payload?.redirectLink,
        },
        avatarColorPalatteDisabled: true,
        avatarSkinTone: {
          id: 'defaultAvatarSkinTone',
          colorCode: defaultAvatarSkinTone,
          name: 'defaultSkinColor',
        },
        avatarHairColor: {
          id: 'defaultAvatarHairColor',
          colorCode: defaultAvatarHairColor,
          name: 'defaultHairColor',
        },
        avatarShirtColor: {
          id: 'defaultAvatarShirtColor',
          colorCode: defaultAvatarShirtColor,
          name: 'defaultShirtColor',
        },
        chosenDisplay: 'avatar',
      };

    case 'CHOOSE_FAMILY_AVATAR':
      return {
        ...state,
        family_avatar: {
          id: action.payload.id,
          code: action.payload.code,
          name: action.payload.name,
          redirectLink: action?.payload?.redirectLink,
        },
        avatarColorPalatteDisabled: true,
        avatarFamilySkinTone: {
          id: 'defaultAvatarSkinTone',
          colorCode: defaultAvatarSkinTone,
          name: 'defaultSkinColor',
        },
        avataFamilyrHairColor: {
          id: 'defaultAvatarHairColor',
          colorCode: defaultAvatarHairColor,
          name: 'defaultHairColor',
        },
        avatarFamilyShirtColor: {
          id: 'defaultAvatarShirtColor',
          colorCode: defaultAvatarShirtColor,
          name: 'defaultShirtColor',
        },
        chosenFamilyDisplay: 'avatar',
      };

    case 'SELECT_AVATAR_SKIN_TONE':
      if (state?.avatarColorPalatteDisabled) {
        return {
          ...state,
          avatarSkinTone: {
            id: action?.payload?.id,
            colorCode: action?.payload?.code,
            name: action?.payload?.name,
          },
        };
      } else {
        return state;
      }

    case 'SELECT_FAMILY_AVATAR_SKIN_TONE':
      if (state?.avatarColorPalatteDisabled) {
        return {
          ...state,
          avatarFamilySkinTone: {
            id: action?.payload?.id,
            colorCode: action?.payload?.code,
            name: action?.payload?.name,
          },
        };
      } else {
        return state;
      }

    case 'SELECT_AVATAR_HAIR_COLOR':
      if (state?.avatarColorPalatteDisabled) {
        return {
          ...state,
          avatarHairColor: {
            id: action?.payload?.id,
            colorCode: action?.payload?.code,
            name: action?.payload?.name,
          },
        };
      } else {
        return state;
      }
    case 'SELECT_FAMILY_AVATAR_HAIR_COLOR':
      if (state?.avatarColorPalatteDisabled) {
        return {
          ...state,
          avatarFamilyHairColor: {
            id: action?.payload.id,
            colorCode: action?.payload.code,
            name: action?.payload.name,
          },
        };
      } else {
        return state;
      }

    case 'SELECT_AVATAR_SHIRT_COLOR':
      if (state?.avatarColorPalatteDisabled) {
        return {
          ...state,
          avatarShirtColor: {
            id: action?.payload?.id,
            colorCode: action?.payload?.code,
            name: action?.payload?.name,
          },
        };
      } else {
        return state;
      }

    case 'SELECT_FAMILY_AVATAR_SHIRT_COLOR':
      if (state?.avatarColorPalatteDisabled) {
        return {
          ...state,
          avatarFamilyShirtColor: {
            id: action?.payload.id,
            colorCode: action?.payload.code,
            name: action?.payload?.name,
          },
        };
      } else {
        return state;
      }

    case 'SELECT_PICTURE':
      return {
        ...state,
        chosenDisplay: 'picture',
        avatarColorPalatteDisabled: false,
        objectURL: action.payload.objectURL,
        fileName: action.payload.fileName,
        isCropped: action.payload.isCropped,
      };

    case 'SAVE_CROPPED_IMAGE':
      return {
        ...state,
        croppedImagePath: action.payload.croppedImage,
        isCropped: action.payload.isCropped,
        chosenDisplay: 'picture',
      };

    case 'SELECT_FAMILY_PICTURE':
      return {
        ...state,
        chosenFamilyDisplay: action.payload.chosenFamilyDisplay,
        familyPictureObjectURL: action.payload.familyPictureObjectURL,
        familyPictureName: action.payload.familyPictureName,
        isFamilyCropped: action.payload.isCropped,
      };

    case 'SAVE_FAMILY_CROPPED_IMAGE':
      return {
        ...state,
        croppedFamilyImagePath: action.payload.croppedImage,
        isFamilyCropped: action.payload.isCropped,
      };

    case 'RESET_FAMILY_DISPLAY_PICTURE':
      return {
        ...state,
        chosenFamilyDisplay: action.payload.chosenFamilyDisplay,
        croppedFamilyImagePath: '',
        isFamilyCropped: false,
        familyPictureObjectURL: '',
        familyPictureName: '',
      };

    case 'RESET_CHOSEN_FAMILY_DISPLAY':
      return {
        ...state,
        chosenFamilyDisplay: action.payload.chosenFamilyDisplay,
      };

    case 'RESET':
      return {
        avatar: null,
        avatarColorPalatteDisabled: false,
        avatarSkinTone: null,
        avatarHairColor: null,
        avatarShirtColor: null,
        chosenDisplay: 'avatar',
      };

    case 'CREATE_NEW_FAMILY_MEMBER':
      return {
        ...state,
        chosenFamilyDisplay: '',
        isFamilyCropped: false,
        croppedFamilyImagePath: '',
        familyPictureObjectURL: '',
        familyPictureName: null
      };

    case 'SET_DEPENDENT_DISPLAY':
      return {
        ...state,
        chosenFamilyDisplay: action.payload.chosenFamilyDisplay,
        isFamilyCropped: action.payload.isFamilyCropped,
        croppedFamilyImagePath: action.payload.croppedImage,
      };

    default:
      return state;
  }
};
